import React from 'react';
import { Box } from '@mui/system';
import { CircularLoader } from '..';
import { styles } from './styles';


const FullScreenLoader = () => {

    const classes = styles();

    return <Box className={ classes.loaderContainer }  >
    <Box style={{ alignSelf: "center" }} >
      <CircularLoader />
    </Box>
  </Box>
}

export default FullScreenLoader;